import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <h4>WintonCoin</h4>
            <p>Homenaje a <a href="legado.html" style={{ color: 'inherit', textDecoration: 'underline', opacity: 0.9, cursor: 'pointer' }}>Sir Nicholas Winton</a></p>
            <h6>Winton Solidario</h6>
            <a href="solicitud-solidaria.html">Postular Causa</a>
          </div>
          <div className="footer-col">
            <h5>Plataforma</h5>
            <Link to="/register">Registrarse</Link>
            <Link to="/login">Ingresar</Link>
            <a href="#como-funciona">Cómo funciona</a>
            <a href="trabaja-con-nosotros.html">Trabaja con nosotros</a>
          </div>
          <div className="footer-col">
            <h5>Recursos</h5>
            <a href="docs.html">Whitepaper</a>
            <a href="roadmap.html">Roadmap & Hitos</a>
            <a href="como-funciona.html#dynamic-academy-grid">Winton Academy</a>
            <a href="pedir-ayuda.html">Guía de Ayuda</a>
            <a href="terms.html">Términos y Condiciones</a>
            <a href="privacy.html">Política de Privacidad</a>
            <a href="faq.html">Preguntas Frecuentes (FAQ)</a>
          </div>
          <div className="footer-col">
            <h5>Boosters</h5>
            <a href="https://boosters.wintoncoin.com/" target="_blank" rel="noopener noreferrer">Programa para Impulsores</a>
            <a href="momentum-landing.html">Winton Momentum</a>
          </div>
          <div className="footer-col social">
            <h5>Comunidad</h5>
            <div className="social-icons">
              <a href="https://x.com/WintonCoin" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a href="https://chat.whatsapp.com/" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.008-.57-.008-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
              </a>
            </div>
            <h6>Contáctanos</h6>
            <a href="mailto:support@wintoncoin.com" className="footer-contact-link">support@wintoncoin.com</a>
          </div>
        </div>
        <div className="footer-bottom">
          &copy; 2026 WintonCoin. Todos los derechos reservados.<br />
          <small style={{ opacity: 0.7 }}>WintonCoin es un producto propiedad de WTN Solutions LLC.</small>
          <span style={{ opacity: 0.6, marginLeft: '10px' }}>| Versión Beta (Acceso Anticipado)</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
